import {
  BoldText,
  DatePolicy,
  ListItem,
  NameItemTitle,
  SimpleText,
  SimpleTextWithoutSpace,
} from "../../PrivatePages/Components/SecurityPage/PolicyPrivacyModel/PolicyPrivacyModelStyle.styled";
import {
  ConatinerPolicyPrivacy,
  TitlePolicyPage,
} from "./PolicyPrivacyPageStyle.styled";

export const PolicyPrivacyPage = () => {
  return (
    <>
      <ConatinerPolicyPrivacy>
        <TitlePolicyPage>Privacy Policy – SafeTasker</TitlePolicyPage>

        <DatePolicy>Effective Date: 09.11.25</DatePolicy>

        <NameItemTitle>1. Introduction</NameItemTitle>
        <SimpleText>
          SafeTasker (“we”, “our”, “us”) respects your privacy and is committed
          to protecting your personal data. This Privacy Policy explains how we
          collect, store, and process your information in compliance with GDPR
          and industry best practices. By using SafeTasker, you agree with this
          policy.
        </SimpleText>
        <NameItemTitle>2. Types of Data We Collect</NameItemTitle>
        <SimpleText>
          We collect and process the following types of data:
        </SimpleText>
        <ol type="1">
          <ListItem>
            <BoldText>Communication Data</BoldText> – Your name and email
            address for account creation, communication, and notifications.
          </ListItem>
          <ListItem>
            <BoldText>Log Data</BoldText> – Security logs generated during
            active sessions, including your temporary IP address, are used to
            prevent abuse and ensure security. All logs are encrypted and
            automatically deleted upon logout.
          </ListItem>
        </ol>
        <NameItemTitle>3. How We Use Your Data</NameItemTitle>
        <SimpleText>
          We use your personal data for the following purposes:
        </SimpleText>
        <ol type="1">
          <ListItem>
            To provide access to SafeTasker services and manage your account.
          </ListItem>
          <ListItem>
            To contact you via email regarding support requests or service
            updates.
          </ListItem>
          <ListItem>
            To reset passwords, update email addresses, or verify account
            ownership.
          </ListItem>
          <ListItem>
            To ensure security, prevent abuse, and maintain system integrity.
          </ListItem>
        </ol>
        <SimpleText>
          Data is <BoldText>never sold or shared with third parties</BoldText>,
          except as required by law.
        </SimpleText>
        <SimpleTextWithoutSpace>
          Access to personal data is restricted to the developer for security or
          legal purposes.
        </SimpleTextWithoutSpace>
        <NameItemTitle>4. Changes to This Privacy Policy</NameItemTitle>
        <SimpleTextWithoutSpace>
          This policy may be updated when necessary to enhance security.
        </SimpleTextWithoutSpace>
        <NameItemTitle>5. Data Storage and Security</NameItemTitle>
        <ol type="1">
          <ListItem>All personal data is encrypted.</ListItem>
          <li>
            <SimpleTextWithoutSpace>
              Temporary logs are stored only during active sessions and deleted
              immediately after logout.
            </SimpleTextWithoutSpace>
          </li>
          <li>
            <SimpleTextWithoutSpace>
              Reasonable administrative, technical, and physical safeguards are
              in place to protect your data from unauthorized access or
              disclosure.
            </SimpleTextWithoutSpace>
          </li>
        </ol>
        <NameItemTitle>6. Data Deletion</NameItemTitle>
        <SimpleText>
          You can request deletion of your data or account at any time. Deleting
          your account will permanently remove all associated information,
          including:
        </SimpleText>
        <ol type="1">
          <li>Name and email</li>
          <li>Tasks and local settings</li>
          <li>Temporary logs</li>
        </ol>
        <NameItemTitle>7. Children’s Privacy</NameItemTitle>
        <SimpleText>
          SafeTasker is
          <BoldText> not intended for users under 13 years old.</BoldText> We do
          not knowingly collect personal data from children under 13
        </SimpleText>
        <NameItemTitle>8. User Rights</NameItemTitle>
        <SimpleText>Under GDPR, you have the right to:</SimpleText>
        <ol type="1">
          <li>Access your personal data</li>
          <li>Request corrections to inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent for data processing where applicable</li>
        </ol>
        <NameItemTitle>9. Access to This Policy</NameItemTitle>
        <SimpleTextWithoutSpace>
          This Privacy Policy is always accessible within your SafeTasker
          account.
        </SimpleTextWithoutSpace>
        <SimpleText>
          Requests can be submitted via the contact email:
          <a href="mailto:support@safe-tasker.com"> support@safe-tasker.com</a>
        </SimpleText>
      </ConatinerPolicyPrivacy>
    </>
  );
};
